import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import getRoleForOrganization from '../utils/GetUserRoleInOrganization';
import PageNotFound from '../pages/PageNotFound/PageNotFound';

const RoleBasedRoute = ({ children, allowedRoles = [], setAccessStatus }) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    setAccessStatus('loading');
    let cancelled = false;

    const checkRole = async () => {
      try {
        const role = await getRoleForOrganization();
        if (cancelled) return;
        if (role && allowedRoles.includes(role)) {
          setStatus('allowed');
          setAccessStatus('allowed');
        } else {
          setStatus('denied');
          setAccessStatus('denied');
        }
      } catch {
        if (!cancelled) {
          setStatus('denied');
          setAccessStatus('denied');
        }
      }
    };

    checkRole();

    return () => {
      cancelled = true;
      setAccessStatus('allowed');
    };
  }, [allowedRoles.join(',')]);

  if (status === 'loading') {
    return (
      <Box sx={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === 'denied') {
    return <PageNotFound />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;
